export const LOAN_AMOUNT_SLIDER_CONFIG = {
  minValue: 300_000,
  maxValue: 200_000_000,
  step: 100_000,
}
